import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RvBadgeComponent } from 'src/app/components/rv-badge/rv-badge.component';

interface InstructionStep {
  icon: string;
  class: string;
  color: string;
  title: string;
  body: string;
}

@Component({
  selector: 'moderator-join-instructions-card',
  standalone: true,
  imports: [MatIconModule, RvBadgeComponent],
  templateUrl: './moderator-join-instructions-card.component.html',
})
export class ModeratorJoinInstructionsCardComponent {
  readonly steps: readonly InstructionStep[] = [
    {
      icon: 'check-in-square',
      color: 'green',
      class: 'medium',
      title: 'Select your displays',
      body: 'Select up to 10 screens to share to all of them at the same time.',
    },
    {
      icon: 'play-no-fill',
      color: 'blue',
      class: 'small',
      title: 'Share your screen',
      body: 'With Displays selected, click "Start Sharing" to begin the session.',
    },
    {
      icon: 'add-user',
      color: 'purple',
      class: 'medium',
      title: 'Invite Participants',
      body: 'Invite participants to the room and choose who shares next.',
    },
  ];
}
